import React, { useState } from 'react';
import './ScheduleModal.css';

const ScheduleModal = ({ isOpen, onClose, onSave, initialSchedule }) => {
  const [selectedDays, setSelectedDays] = useState(initialSchedule?.days || []);
  const [startDate, setStartDate] = useState(initialSchedule?.startDate || '');
  const [endDate, setEndDate] = useState(initialSchedule?.endDate || '');
  
  const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  const handleDayToggle = (day) => {
    setSelectedDays(prev => 
      prev.includes(day) 
        ? prev.filter(d => d !== day)
        : [...prev, day]
    );
  };

  const handleSave = () => {
    if (!startDate) {
      alert('Please select a start date');
      return;
    }
    if (endDate && new Date(endDate) < new Date(startDate)) {
      alert('End date must be after start date');
      return;
    }
    onSave({
      days: selectedDays,
      startDate,
      endDate
    });
    onClose();
  };

  const today = new Date().toISOString().split('T')[0];

  if (!isOpen) return null;

  return (
    <div className="schedule-modal-overlay" onClick={onClose}>
      <div className="schedule-modal" onClick={e => e.stopPropagation()}>
        <div className="schedule-modal-header">
          <h2>Schedule Template</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="schedule-modal-content">
          <div className="date-range-container">
            <div className="date-field">
              <label htmlFor="start-date">Start Date:</label>
              <input
                type="date"
                id="start-date"
                min={today}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </div>
            <div className="date-field">
              <label htmlFor="end-date">End Date (Optional):</label>
              <input
                type="date"
                id="end-date"
                min={startDate || today}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
          
          <p>Select which days this template should be automatically copied to Active Forms:</p>
          <div className="days-container">
            {daysOfWeek.map(day => (
              <label key={day} className="day-checkbox">
                <input
                  type="checkbox"
                  checked={selectedDays.includes(day)}
                  onChange={() => handleDayToggle(day)}
                />
                <span className="day-label">{day}</span>
              </label>
            ))}
          </div>
          <p className="schedule-note">
            Note: Forms will be created at midnight on the selected days between the specified dates
          </p>
        </div>
        <div className="schedule-modal-footer">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="save-button" onClick={handleSave}>Save Schedule</button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleModal;
